import Instrument from "../Instrument";

class DrumKitCR8000 extends Instrument {

	constructor(path) {
		super("DrumKitCR8000", DrumKitCR8000.nice_name, path);

		this.createParameter("octave", {
			min: -1,
			max: 4,
			default: 1,
			lock_step: true
		});

		this.samples = [
			"cr8000/CR8KBASS.wav",
			"cr8000/CR8KCLAP.wav",
			"cr8000/CR8KSNAR.wav",
			"cr8000/CR8KCHAT.wav",
			"cr8000/CR8KCLAV.wav",
			"cr8000/CR8KCOWB.wav",
			"cr8000/CR8KCYMB.wav",
			"cr8000/CR8KHITM.wav",
			"cr8000/CR8KLCNG.wav",
			"cr8000/CR8KLOTM.wav",
			"cr8000/CR8KMCNG.wav",
			"cr8000/CR8KOHAT.wav",
			"cr8000/CR8KRIM.wav",

		];

		this.loaded = false;
		this.context = false;
	}

	scheduleNote(notes, time, tonic, scale) {
		var len = notes.length;
		if(len > 0 && this.loaded) {
			for(var i = len - 1; i >= 0; i--) {
				if(this.samples[notes[i]]) {
					this.playSample(this.context, this.gain, this.samples[notes[i]], time);
				}
			}
		}
	}

	getNotesNames() {
		return [
			"KICK", "CLAP", "SNAR", "CHAT", "CLAV", "COWB",
			"CYMB", "HITM", "LCNG", "LOTM", "OHAT", "RIMS"
		]
	}

	createNodes(context) {

		this.loadSamples(context, this.samples).then(() => {
			this.loaded = true;
		});

		this.context = context;

		var gainNode = context.createGain();

		gainNode.gain.value = 1;

		this.gain = gainNode;

		return {
			connect: (node) => {
				gainNode.connect(node);
			},
			disconnect: (node) => {
				gainNode.disconnect(node);
			}
		};

	}
}

DrumKitCR8000.nice_name = 'CR8000';

export default DrumKitCR8000;
